import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { USER_TAG_META_MAP, USER_TAGS, UserTagViewModel } from '@interfaces';

@Component({
  selector: 'app-cr-user-tag-selector',
  templateUrl: './cr-user-tag-selector.component.html',
  styleUrls: ['./cr-user-tag-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CrUserTagSelectorComponent implements OnChanges {
  public userTags: UserTagViewModel[] = Object.values(USER_TAGS).map(tag => ({
    name: tag,
    icon: USER_TAG_META_MAP[tag].icon,
    color: USER_TAG_META_MAP[tag].color,
    label: `MANAGEMENT.TAG_MANAGER.TAG.${tag}`,
  }));

  @Input() selectedTag: USER_TAGS | null = null;
  @Output() selectedTagChanged = new EventEmitter<{ selectedTag: USER_TAGS | null }>();

  public selectedTagViewModel: UserTagViewModel | null = null;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTag']) {
      this.selectedTagViewModel = this.getSelectedTagViewModel(this.selectedTag);
    }
  }

  public onSelectedTagChange(selectedTag: USER_TAGS | null): void {
    this.selectedTagViewModel = this.getSelectedTagViewModel(selectedTag);
    this.selectedTagChanged.emit({ selectedTag });
  }

  public clearSelectedTag(): void {
    this.selectedTag = null;
    this.selectedTagViewModel = null;
    this.selectedTagChanged.emit({ selectedTag: null });
  }

  private getSelectedTagViewModel(selectedTag: USER_TAGS | null): UserTagViewModel | null {
    return this.userTags.find(({ name }) => name === selectedTag) ?? null;
  }
}
